import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '@app/core/services';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateIn',
})
export class TranslateInPipe implements PipeTransform {
  private readonly translateService: TranslateService = inject(TranslateService);
  private readonly i18nService: I18nService = inject(I18nService);

  transform(key: string, language: string): string {
    if (!key) {
      return '';
    }
    return this.i18nService.getTranslation(key, language);
  }
}
